<template>
  <div class="position-settings">
    <el-form :inline="true" size="small" :model="dataForm" @keyup.enter.native="getDataList()">
      <el-form-item label="被授权用户名:">
        <el-input size="small" v-model="dataForm.objectUserName" placeholder="被授权用户名" clearable></el-input>
      </el-form-item>
      <el-form-item label="被授权用户姓名:">
        <el-input size="small" v-model="dataForm.objectUserRealName" placeholder="被授权用户姓名" clearable></el-input>
      </el-form-item>
      <el-form-item label="授权采购组代码:">
        <el-input size="small" v-model="dataForm.subjectPosCode" placeholder="授权采购组代码" clearable></el-input>
      </el-form-item>
      <el-form-item label="授权采购组名称:">
        <el-input size="small" v-model="dataForm.subjectPosName" placeholder="授权采购组名称" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" @click="getDataList()" icon="el-icon-search">
          查询
        </el-button>
        <el-button size="small" type="primary" @click="addOrUpdateHandle()" icon="el-icon-plus">
          新增
        </el-button>
<!--        <el-button size="small" type="danger" @click="deleteBatchHandle()" icon="el-icon-delete" :disabled="dataListSelections.length <= 0">-->
<!--          删除-->
<!--        </el-button>-->
      </el-form-item>
    </el-form>
    <el-table :data="dataList" v-loading="dataListLoading" size="small" :height=documentClientHeight
              @selection-change="selectionChangeHandle" style="width: 100%;">
      <el-table-column type="selection" header-align="center" align="center" width="50">
      </el-table-column>
      <el-table-column type="index" label="序号" header-align="left" align="left" width="50">
      </el-table-column>
      <el-table-column prop="objectUserName" header-align="left" align="left" width="120" label="被授权用户名">
      </el-table-column>
      <el-table-column prop="objectUserRealName" header-align="left" align="left" width="120" label="被授权用户姓名">
      </el-table-column>
      <el-table-column prop="subjectPosCode" header-align="left" align="left" width="120" label="授权采购组代码">
      </el-table-column>
      <el-table-column prop="subjectPosName" header-align="left" align="left" width="150" label="授权采购组名称">
      </el-table-column>
      <el-table-column prop="createTime" header-align="left" align="left" width="150" label="创建时间">
      </el-table-column>
      <el-table-column header-align="left" align="left" min-width="80" label="操作">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="deleteHandle(scope.row.id)" icon="el-icon-delete">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex"
                   :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalPage"
                   layout="total, sizes, prev, pager, next, jumper">
    </el-pagination>
    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
  </div>
</template>

<script>
import { queryXysqPage, deleteXysq } from '@/controller/rfq'
import AddOrUpdate from './xysq-add-or-update.vue'

export default {
  data() {
    return {
      documentClientHeight: document.documentElement['clientHeight'] - 220,
      dataForm: {
        objectUserName: '',
        objectUserRealName: '',
        subjectPosCode: '',
        subjectPosName: ''
      },
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false,
    }
  },
  components: {
    AddOrUpdate,
  },
  activated() {
    this.getDataList()
  },
  methods: {
    // 获取数据列表
    getDataList() {
      this.dataListLoading = true
      queryXysqPage({
        'pageNo': this.pageIndex,
        'pageSize': this.pageSize,
        'objectUserName': this.dataForm.objectUserName,
        'objectUserRealName': this.dataForm.objectUserRealName,
        'subjectPosCode': this.dataForm.subjectPosCode,
        'subjectPosName': this.dataForm.subjectPosName,
        'tenantId': sessionStorage.getItem('tenantId'),
        'mainBodyId': sessionStorage.getItem('mainBodyId')
      }).then(data => {
        if (data && data.code === '00') {
          this.dataList = data.body.records
          this.totalPage = data.body.total
        } else {
          this.dataList = []
          this.totalPage = 0
        }
        this.dataListLoading = false
      })
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 多选
    selectionChangeHandle(val) {
      this.dataListSelections = val
    },
    // 新增 / 修改
    addOrUpdateHandle(id) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id)
      })
    },
    // 删除
    deleteHandle(id) {
      this.$confirm(`确定进行删除操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteXysq({'id': id}).then(data => {
          if (data && data.code === '00') {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.getDataList()
              }
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      }).catch(() => {})
    },
    // 批量删除
    deleteBatchHandle() {
      const ids = this.dataListSelections.map(item => item.id)
      this.$confirm(`确定删除选中的${ids.length}条数据?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteXysq({'ids': ids}).then(data => {
          if (data && data.code === '00') {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.getDataList()
              }
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      }).catch(() => {})
    }
  }
}
</script>